// stores/auth.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import router from '@/router'
import api, { urls } from '@/api'

export const useAuthStore = defineStore('auth', () => {
    // State (메모리에만 저장 - 새로고침 시 초기화됨)
    const accessToken = ref(null)
    const user = ref(null)

    // Getters
    const isAuthenticated = computed(() => !!accessToken.value)
    const getToken = computed(() => accessToken.value)
    const getUser = computed(() => user.value)

    // Actions
    const setToken = (token) => {
        accessToken.value = token
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    }

    const setUser = (userData) => {
        user.value = userData
    }

    const clearAuth = () => {
        accessToken.value = null
        user.value = null
    }

    // 로그인
    const login = async (credentials) => {
        try {        
            const res = await api.post(urls.login.login, credentials)
            const data = res.data
            let error = ''

            if (data.token) {
                // 토큰, user 저장
                setToken(data.token)
                setUser(data.user)
            } else {
                error = data.error || '아이디 또는 비밀번호가 올바르지 않습니다.';
            }
            
            return {
                error: error,
                status: data.status,
                refreshToken: data.refreshToken
            };
        } catch (err) {
            // error 처리
            return {
                error: '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
                status: 'error'
            };
        }
    }

    // 로그아웃
    const logout = (params) => {
        try {
            // localStorage.setItem('preventAutoLogin', 'true');
            const safeParams = params && typeof params === 'object' ? params : {};

            api.post(urls.login.logout, safeParams)
            .then(res => {
                // console.log(res.data)
            })
        } catch (error) {
            // console.error('Logout error:', error)
        } finally {
            delete api.defaults.headers.common['Authorization'];
            clearAuth()
            router.push('/')
        }
    }

    // user 상태 확인
    const userInfo = async () => {
        try {
            const res = await api.post(urls.login.userInfo)
            const data = res.data

            if(data.token){
                setToken(data.token)
                setUser(data.user)
                return true
            }
            return false
        } catch (err) {
            clearAuth()
            return false
        }
    }

    const refreshAccessToken = async (params) => {
        try {
            const res = await api.post(urls.login.refresh, params)
            const data = res.data

            if(data.token){
                setToken(data.token)
                setUser(data.user)
                return true
            }

            return false
        } catch (err) {
            clearAuth()
            return false
        }
    }

    return {
        // State
        accessToken,
        user,

        // Getters
        isAuthenticated,
        getToken,
        getUser,

        // Actions
        setToken,
        setUser,
        clearAuth,
        login,
        logout,
        userInfo,
        refreshAccessToken
    }
})